/**
 * Text size for the desktop app.
 *
 * Desktop only, through Electron's own zoom (window.electronAPI.setZoomFactor),
 * which scales everything, maps included, the way a browser's Ctrl + does. The
 * desktop window has no menu bar, so it has no Ctrl + of its own; this is it.
 *
 * Not CSS `zoom` on the web: a zoomed page counts 100vh as 125% of the window,
 * so the full-height layout overflows. In a browser, the browser's zoom is the
 * same thing done properly, and Settings says so.
 *
 * Kept per machine (localStorage), not on the pilot's record: the right size
 * depends on the screen, and the same pilot may fly from two.
 */
export const TEXT_SIZES = [
  { id: "default", label: "Default", factor: 1 },
  { id: "large",   label: "Large",   factor: 1.125 },
  { id: "larger",  label: "Larger",  factor: 1.25 },
  { id: "largest", label: "Largest", factor: 1.4 },
];

const KEY = "vacars5_text_size";

export const canSetTextSize = (win = window) =>
  typeof win?.electronAPI?.setZoomFactor === "function";

export function getTextSize(storage = globalThis.localStorage) {
  try {
    const v = storage?.getItem(KEY);
    return TEXT_SIZES.some((s) => s.id === v) ? v : "default";
  } catch {
    return "default";
  }
}

export function applyTextSize(id, win = window) {
  if (!canSetTextSize(win)) return;
  const size = TEXT_SIZES.find((s) => s.id === id) || TEXT_SIZES[0];
  win.electronAPI.setZoomFactor(size.factor);
}

export function setTextSize(id, win = window, storage = globalThis.localStorage) {
  try { storage?.setItem(KEY, id); } catch { /* private mode: applies for this session only */ }
  applyTextSize(id, win);
}
